var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 35,
    r: 35,
    fill: "#EB5757"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.702 18.472L35 29.174 24.298 18.472l-5.826 5.826L29.174 35 18.472 45.702l5.826 5.826L35 40.826l10.702 10.702 5.826-5.826L40.826 35l10.702-10.702-5.826-5.826z",
    fill: "#fff"
  })));
}
export default __webpack_public_path__ + "static/media/error-icon.6db347c3.svg";
export { SvgErrorIcon as ReactComponent };